import { JSXElementConstructor } from 'react';
import { nortadaLogger } from '../logger';
import { State, STEP } from './searchByOperationIdReducer';
import Search from './search';
import { DetailsType } from '../details-list/interface';

interface Props {
  state: State;
  isSearching: boolean;
  handleSearch: (operationId: string) => void;
  Results: JSXElementConstructor<{ operation: unknown; detailsType?: DetailsType }>;
  detailsType?: DetailsType;
}

const SearchByOperationId = ({ state, handleSearch, isSearching, Results, detailsType = 'operation' }: Props) => {
  const getPage = () => {
    switch (state.currentPage) {
      case STEP.SEARCH: {
        return (
          <Search
            handleSearch={handleSearch}
            isSearching={isSearching}
            error={state.payload?.error}
            detailsType={detailsType}
          />
        );
      }
      case STEP.RESULTS: {
        return <Results operation={state.payload} detailsType={detailsType} />;
      }
      default: {
        throw nortadaLogger.critical(`${state.currentPage} page is not supported`);
      }
    }
  };

  return getPage();
};
export default SearchByOperationId;
